module.exports = __webpack_public_path__ + "static/icons/icon-map--japan-7fc88a9db893289c896f8447ab4b6470.svg";